
const resolutionBreakpoint = 960

const isMobile = () => { return (window.innerWidth <= resolutionBreakpoint || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ; }

export const lowResolution = () => {return (window.innerWidth <= resolutionBreakpoint)}

export default isMobile;